module.exports = __webpack_public_path__ + "img/carousel-1.bd3b6872.png";